<template>
    <date-picker 
        v-model="dp_datetime" 
        :config="dp_config"
        @dp-change="(ev) => {
            dateTimeChanged(ev.date);   
        }">
    </date-picker>
</template>

<script>
    import moment from 'moment';
    import datePicker from 'vue-bootstrap-datetimepicker';
    import { 
        SERVER_FORMAT, 
        LOCAL_FORMAT
    } from "@/constants.js";
    
    export default {
        components: {
            datePicker
        },

        props: {
            datestring: {},
            config: {
                default: () => { return {}; }
            }
        },

        data() {
            return {
                dp_datetime: null,
                dp_config: null,
                internal_config: {
                    format: SERVER_FORMAT,
                    display_format: LOCAL_FORMAT,
                    ...this.config
                }
            }
        },

        created() {
            if (this.datestring !== null) {
                this.dp_datetime = moment(this.datestring, this.config.format).format(this.config.display_format);
            } else {
                // If no defined date, assume start of current day and emit as default value
                let m = moment().startOf('day');
                this.dp_datetime = m.format(this.config.display_format);
                this.dateTimeChanged(m);
            }
            
            this.dp_config = {
                format: this.internal_config.display_format
            };
        },

        methods: {
            dateTimeChanged(m) {
                this.$emit('changed', m.format(this.config.format));
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
